import { Routes } from '@angular/router';
import { UnauthorizedComponent } from 'app/unauthorized/components/unauthorized/unauthorized.component';

export const unauthorizedRoutes: Routes = [
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  }
];
